<template>
   <SplitEditor
    mode="python"
    theme="solarized_light"
    :splits="1"
    orientation="beside"
    width="100%"
    name="editor"
    :value="[value]"
    :enableBasicAutocompletion="true"
    :tabSize="4"
    :onChange="onChange"
    :editorProps="{
      $blockScrolling: true,
    }"
  />
</template>

<script>
  import CodeMirror from 'codemirror';
  import 'codemirror/lib/codemirror.css'

  import { Split as SplitEditor } from 'vue2-brace-editor';

  import 'brace/mode/python';
  import 'brace/theme/solarized_light';

  export default {
    name: "CodeEditor",
    components: {
      SplitEditor,
    },
    props: {
      value: ""
    },
    $el: 'root',
    methods: {
      onChange(newValue) {
         this.$emit('input', newValue[0]);
      }
    }
  }
</script>
